import React from 'react';
import PropTypes from 'prop-types';
import Bar from '../VerticalDiagram/Bar';
import { Arrow, BarPlaceHolder, Column } from '../VerticalDiagram/styles';
import { AreaName, ArrowCommon, ArrowNext, ArrowPrev, Header, FlexContent, ResultTitle, SmartTitle, Title, Totals, Participation } from './styles';
import { percentFormat } from '../../Utils/NumberFormatting';
import { getCandidateFace } from '../../Utils/Getters';

export default class Head2HeadWidget extends React.PureComponent {

	constructor(props) {
		super(props);

		const areas = Array.from(new Set(this.props.finalists.map(finalist => finalist.area.id))).sort((a, b) => a - b);
		const index = Math.floor(Math.random() * areas.length);

		this.state = { index, areas };
	}

	moveNext = () => {
		this.setState(state => ({
			index: (state.index + 1) % state.areas.length
		}));
		this.props.onUpdate()
	}

	movePrev = () => {
		this.setState(state => ({
			index: (state.index === 0 ? state.areas.length : state.index) - 1
		}));
		this.props.onUpdate()
	}

	render() {
		const finalists = this.props.finalists.filter(finalist => finalist.area.id === this.state.areas[this.state.index]);
		const area = finalists[0].area;
		const winAfterFirstRound = finalists.length === 1

		return <>
			<Header>
				<Title>
					<SmartTitle>Senátní volby - </SmartTitle>
					{winAfterFirstRound ? <ResultTitle>Výsledky po 1. kole:</ResultTitle> : <ResultTitle>Výsledky ve 2. kole:</ResultTitle>}
				</Title>
				<AreaName>
					{area.name}
					{!winAfterFirstRound && <Totals>Sečteno: {percentFormat(area.count[this.props.roundIndex], 2)}</Totals>}
					{!winAfterFirstRound && <Participation>Volební účast: {percentFormat(this.props.meta[this.props.roundIndex].turnout, 2)}</Participation>}
				</AreaName>
				{this.props.children}
			</Header>
			<FlexContent>
				<Arrow><ArrowPrev onClick={this.movePrev} className={ArrowCommon} /></Arrow>
				{finalists.map((finalist, index, array) => {
					const roundIndex = winAfterFirstRound ? 0 : this.props.roundIndex
					return <>
						<Bar
							key={finalist.id}
							roundIndex={roundIndex}
							max={array[0].percent[roundIndex]}
							face={getCandidateFace(this.props.faces, finalist.id)}
							{...finalist}
							winAfterFirstRound={winAfterFirstRound}
						/>
						{winAfterFirstRound && <BarPlaceHolder>
							Vyhrává v prvním kole
						</BarPlaceHolder>}
					</>
				})}
				<Arrow><ArrowNext onClick={this.moveNext} className={ArrowCommon} /></Arrow>
			</FlexContent>
		</>;
	}
}

Head2HeadWidget.propTypes = {
	finalists: PropTypes.arrayOf(PropTypes.shape({
		id: PropTypes.string.isRequired,
		name: PropTypes.string.isRequired,
		lastName: PropTypes.string.isRequired,
		area: PropTypes.shape({
			id: PropTypes.number.isRequired,
			name: PropTypes.string.isRequired,
			count: PropTypes.arrayOf(PropTypes.number).isRequired
		}).isRequired,
		percent: PropTypes.arrayOf(PropTypes.number).isRequired
	})).isRequired,
	faces: PropTypes.object.isRequired,
	roundIndex: PropTypes.number.isRequired
};

Head2HeadWidget.defaultProps = {
	faces: {},
	meta: [
		{ id: 0, count: 0, turnout: 0, isFinal: false },
		{ id: 1, count: 0, turnout: 0, isFinal: false }
	]
};
